import { useState } from 'react'
import { PhotoIcon } from '@heroicons/react/24/outline'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type TableImageProps = WithClassName<{
	src: string | null
	alt?: string
	count?: number
}>

export const TableImage = ({ src, count, alt = '', className }: TableImageProps) => {
	const [hasError, setHasError] = useState(false)
	const showImage = !!src && !hasError

	return (
		<figure
			className={cn(
				'relative grid h-9 w-9 shrink-0 place-items-center overflow-hidden rounded-md border border-border bg-muted text-muted-foreground',
				className
			)}>
			{showImage ? (
				<img
					src={src}
					alt={alt}
					className="h-full w-full object-cover"
					onError={() => setHasError(true)}
				/>
			) : (
				<PhotoIcon className="h-4 w-4 stroke-2" />
			)}

			{count ? (
				<div className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded bg-primary px-1 text-[10px] font-semibold text-primary-foreground md:hidden">
					{count}
				</div>
			) : null}
		</figure>
	)
}
